type Falsey = undefined | null | false | '' | 0

function isTruthy<T>(value?: T | Falsey): value is T {
  return !!value
}

/**
 * `filterTruthy` is a typed version of `[].filter(Boolean)
 *
 * @param list list of truthy and `Falsey` items
 * @returns a new list with `Falsey` values removed
 */
export const filterTruthy = <T>(list: (T | Falsey)[]) => list.filter(isTruthy)
